import React, { createContext, useContext } from 'react'
import Bowser from 'bowser'
import { IEWarning } from './IEWarning'
import { Header } from './Header'
import { Footer } from './Footer'
import { SlidingMenu } from './Navigation'
import { useToggle } from '@hooks'

export const AppContext = createContext({
  isMenuOpen: false,
})

export const Layout = ({ children }) => {
  const { isToggled, toggle } = useToggle(false)
  // get current browser is window is defined
  if (typeof window !== `undefined`) {
    var browser = Bowser.getParser(window.navigator.userAgent)
  } else {
    return null
  }
  return (
    <AppContext.Provider
      value={{
        isMenuOpen: isToggled,
        toggleMenu: toggle,
      }}
    >
      <div className="relative antialiased font-body">
        {browser !== null &&
        browser.getBrowserName().includes(`Internet Explorer`) ? (
          <IEWarning />
        ) : (
          <>
            <Header />
            <SlidingMenu />
            <main className="bg-gray-200">{children}</main>
            <Footer />
          </>
        )}
      </div>
    </AppContext.Provider>
  )
}

export const useAppState = () => useContext(AppContext)
